// Dependencies
import styled from 'styled-components';

const OldBrowserNoticeStyles = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  padding: 1.75rem 0;
  text-align: center;
  background-color: var(--color-sand);
  box-shadow: 0.313rem 0.313rem 0.625rem 0.313rem rgba(0, 0, 0, 5%);

  .heading {
    margin: 0;
    font-size: 1rem;
    font-weight: var(--font-weight-bold);
  }
`;

export default OldBrowserNoticeStyles;
